import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Button } from '@wordpress/components';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/**
 * A button useful for a launcher of a dropdown component. The button is 100% width of its container and displays
 * single or multiple lines rendered as `<span/>` elments.
 *
 * @param { object } props Props passed to component.
 * @return { object } -
 */

var DropdownButton = function DropdownButton(props) {
  var labels = props.labels,
      isOpen = props.isOpen,
      otherProps = _objectWithoutProperties(props, ["labels", "isOpen"]);

  var buttonClasses = classnames('woocommerce-dropdown-button', {
    'is-open': isOpen,
    'is-multi-line': labels.length > 1
  });
  return createElement(Button, _extends({
    className: buttonClasses,
    "aria-expanded": isOpen
  }, otherProps), createElement("div", {
    className: "woocommerce-dropdown-button__labels"
  }, labels.map(function (label, i) {
    return createElement("span", {
      key: i
    }, label);
  })));
};

DropdownButton.propTypes = {
  /**
   * An array of elements to be rendered as the content of the button.
   */
  labels: PropTypes.array.isRequired,

  /**
   * Boolean describing if the dropdown in open or not.
   */
  isOpen: PropTypes.bool
};
export default DropdownButton;
//# sourceMappingURL=index.js.map